// extracted by mini-css-extract-plugin
export default {"title":"horizontalcard2_title__8ds2-","card":"horizontalcard2_card__udFsW"};